// ActionAdd Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import currency from '../../../../lib/currency.jsx'

class ActionAdd extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      showOptions: false
    }
  }

  static get propTypes () {
    return {
      showLabel: PropTypes.bool,
      showOptions: PropTypes.bool,
      activeFilters: PropTypes.array,
      onAddActivity: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      showLabel: true,
      showOptions: false,
      activeFilters: [],
      onAddActivity: null
    }
  }

  render () {
    const { showLabel, activeFilters } = this.props
    const { showOptions } = this.state

    let icon = ''
    if (currency.getCurrency() === 'USD') {
      icon = 'dollar'
    } else if (currency.getCurrency() === 'GBP') {
      icon = 'pound'
    } else {
      icon = 'euro'
    }

    const actions = [
      {
        ident: 'expense-activity',
        icon: icon,
        iconSize: icon === 'euro' ? '24' : '10',
        type: 'default',
        className: 'action'
      },
      {
        ident: 'time-activity',
        icon: 'timer',
        iconSize: '24',
        type: 'default',
        className: 'timericon'
      },
      {
        ident: 'text',
        icon: 'text',
        iconSize: '24',
        type: 'default',
        className: 'action'
      }
    ]

    let isShowTimeText = false
    let isShowExpenseText = false

    if (activeFilters && activeFilters.length > 0) {
      activeFilters.forEach(filter => {
        if (filter === 'time') {
          isShowTimeText = true
        } else if (filter === 'expense') {
          isShowExpenseText = true
        }
      })
    }

    return (
      <div className={`action-add${showOptions ? ' active' : ''}`}>
        {!showOptions && (
          <div className='action-add-content'>
            <IconButton
              icon='+'
              type='default'
              size='small'
              label={showLabel ? 'project.budgetContent.labelAddActivity' : ''}
              className={showLabel ? 'commonadd' : 'inlineadd'}
              canHover
              onClick={this._onShowOptions} // eslint-disable-line react/jsx-handler-names
            />
          </div>
        )}
        {showOptions && (
          <div className={`action-option${showLabel ? ' commonadd' : ''}`}>
            <IconButton
              icon='x'
              type='error'
              size='small'
              className='actionclose'
              onClick={this._onCloseOptions} // eslint-disable-line react/jsx-handler-names
            />
            {actions.map(action => {
              const { ident, ...others } = action
              let bShowItem = activeFilters.length === 0
              if (!bShowItem) {
                if (ident === 'time-activity') {
                  bShowItem = activeFilters.indexOf('time') >= 0
                } else if (ident === 'expense-activity') {
                  bShowItem = activeFilters.indexOf('expense') >= 0
                }
              }

              if (!bShowItem) {
                return null
              }

              return (
                <IconButton
                  key={ident}
                  {...others}
                  onClick={this._onAddActivity.bind(this, ident)}
                />
              )
            })}
            <div className='label'>
              {isShowExpenseText && (
                <IntlMessage ident='project.budgetContent.labelAddExpenseActivities' />
              )}
              {isShowTimeText && (
                <IntlMessage ident='project.budgetContent.labelAddTimeActivities' />
              )}
              {!isShowExpenseText && !isShowTimeText && (
                <IntlMessage ident='project.budgetContent.labelAddActivities' />
              )}
            </div>
          </div>
        )}
      </div>
    )
  }

  /* Event handlers */
  _onShowOptions = () => {
    this.setState({ showOptions: true })
  }

  _onCloseOptions = () => {
    this.setState({ showOptions: false })
  }

  _onAddActivity = type => {
    this._onCloseOptions()

    const { onAddActivity } = this.props

    if (onAddActivity) {
      onAddActivity(type)
    }
  }
}

export default ActionAdd
